import { Id } from "@dgs/core";

export type FilterOperator =
	| "BETWEEN"
	| "EQUAL"
	| "NOT_EQUAL"
	| "CONTAINS"
	| "NOT_CONTAINS"
	| "IN"
	| "NOT_IN"
	| "GREATER_THAN_EQUAL"
	| "LESS_THAN_EQUAL"
	| "EQUAL_DATE_TIME"
	| "NOT_EQUAL_DATE_TIME"
	| "EQUAL_RELATION"
	| "NOT_EQUAL_RELATION"
	| "CONTAINS_RELATION"
	| "NOT_CONTAINS_RELATION"
	| "IN_RELATION"
	| "NOT_IN_RELATION"
	| "EQUAL_APPLICATION_TYPE"
	| "NOT_EQUAL_APPLICATION_TYPE"
	| "IN_APPLICATION_TYPE"
	| "NOT_IN_APPLICATION_TYPE"
	| "EQUAL_ADDRESSES_COUNTRY"
	| "NOT_EQUAL_ADDRESSES_COUNTRY"
	| "IN_ADDRESSES_COUNTRY"
	| "NOT_IN_ADDRESSES_COUNTRY"
	| "EVENT_HAS_PARTICIPATION_STATUS";

type FilterableFields = {
	EVENT:
		| "START"
		| "END"
		| "ADDRESS_COUNTRY"
		| "ADDRESS_CITY"
		| "TAGS"
		| "EVENT_TYPE"
		| "INDUSTRIES"
		| "REGION"
		| "PRIMARY_ORGANIZATIONAL_UNIT"
		| "ORGANIZATIONAL_UNITS"
		| "TARGET_GROUP"
		| "FORMAT"
		| "EVENT_CATEGORY"
		| "ORGANIZER"
		| "LOCATION"
		| "EVENT_PARTICIPATION_STATUS";
	APPLICATION: "SETUP_DATE" | "DELETION_DATE" | "TYPE";
};

export type FilterableEntity = keyof FilterableFields;

export type FilterableField = FilterableFields[FilterableEntity];

export interface FilterItem {
	entity: FilterableEntity;
	field: FilterableField;
	operator: FilterOperator;
	value: any;
	operators: FilterOperator[];
}

export interface FilterItemFormValues {
	entity: FilterableEntity;
	field: FilterableField;
	operator: FilterOperator | null;
	value: any;
	operators: FilterOperator[];
}

export interface FilterableItem {
	entity: FilterableEntity;
	field: FilterableField;
	operators: FilterOperator[];
}

export interface FilterIndexResource {
	id: Id;
	name: string;
	type: FilterType;
	entity: FilterableEntity;
	lastUsedAt: string | null;
	items: FilterItem[];
}

export interface FilterableFieldResource {
	field: FilterableField;
	operators: FilterOperator[];
}

export interface FilterOptionResource extends FilterIndexResource {
	mode: FilterMode;
	filterItems: FilterItem[];
}

export type FilterUpdateResource = FilterOptionResource;

export enum FilterMode {
	QUICK = "QUICK",
	ADVANCED = "ADVANCED",
}

export interface OnDemandFilterFormValues {
	mode: FilterMode;
	filterItems: FilterItem[];
}

export interface FilterFormValues extends OnDemandFilterFormValues {
	name: string | null;
	entity: FilterableEntity;
	type: FilterType;
}

export type FilterType = "ON_DEMAND" | "SYSTEM" | "PUBLIC" | "PERSONAL";

export type FilterSaveRequest = FilterFormValues;
